// extracted by mini-css-extract-plugin
export default {"accessibilityButton":"AccessibilityButton_accessibilityButton__2C0zG"};